import React, { Component } from 'react';
import componentLookUp from '../../../shared/core/components.map';

type FsMyFilesPagePropsType = {
    components: string[]
}

type FsMyFilesPageState = {
    isLoaded: boolean,
    error: null,
    data: any
}

class FsMyFilesPage extends Component<FsMyFilesPagePropsType, FsMyFilesPageState> {
    render() {
        return(
            <>
                { this.props.components.map( (comp, index) => 
                    <div key={index}>{ componentLookUp(comp) }</div>
                )}
            </>
        )
    }
}

export default FsMyFilesPage;